// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-j_ha","advertDetailHeaderLocation__value":"c-j_hb"};